'use client';

import React from 'react';
import { OFFICES } from '@/constants/offices';

const MobileOfficeGrid: React.FC = () => {
  return (
    <div className="grid grid-cols-2 xl:hidden gap-3 sm:gap-6 w-full max-w-3xl mx-auto px-4 sm:px-0">
      {OFFICES.map(({ name, address, image }) => (
        <div
          key={name}
          className="flex flex-col bg-white rounded-lg overflow-hidden shadow-md border border-gray-100 w-full h-full"
        >
          {image ? (
            <img
              src={image}
              alt={name}
              className="w-full h-[90px] xs:h-[110px] sm:h-[150px] object-cover"
            />
          ) : (
            <div className="w-full h-[90px] xs:h-[110px] sm:h-[150px] bg-gray-200 flex items-center justify-center">
              <span className="text-gray-500 text-xs sm:text-sm">Image coming soon</span>
            </div>
          )}
          <div className="p-2 sm:p-4 flex flex-col gap-1 sm:gap-2 flex-grow bg-white">
            <p className="m-0 font-semibold text-[#02435D] text-[13px] sm:text-base leading-tight">
              {name}
            </p>
            <p className="m-0 font-normal text-[#02435D] text-[11px] sm:text-sm leading-snug">
              {address}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileOfficeGrid;
